import React, { useEffect, useRef, useState } from "react";
import Motif from "./Motif";

const BURST_TYPES = ["heart", "swirl", "spark", "petal"];

function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function Personality() {
  const [bits, setBits] = useState([]);
  const lastPhoto = useRef(0);

  useEffect(() => {
    const pending = [];

    function addBits(next) {
      setBits((prev) => [...prev, ...next]);
      const timer = window.setTimeout(() => {
        setBits((prev) => prev.filter((bit) => !next.some((n) => n.id === bit.id)));
      }, 1100);
      pending.push(timer);
    }

    function burstAt(originX, originY, count, upward) {
      const next = Array.from({ length: count }, (_, i) => {
        const angle = upward
          ? -Math.PI / 2 + (Math.random() - 0.5) * 1.3
          : (Math.PI * 2 * i) / count + Math.random() * 0.4;
        const dist = upward ? 50 + Math.random() * 80 : 56 + Math.random() * 90;
        return {
          id: `${originX}-${originY}-${i}-${Math.random().toString(16).slice(2)}`,
          type: BURST_TYPES[i % BURST_TYPES.length],
          x: originX,
          y: originY,
          dx: Math.cos(angle) * dist,
          dy: Math.sin(angle) * dist - (upward ? 20 : 36),
          rot: Math.round((Math.random() - 0.5) * 220),
          hue: i % 3,
        };
      });
      addBits(next);
    }

    function onClick(event) {
      if (prefersReducedMotion()) return;
      if (event.button !== 0) return;
      burstAt(event.clientX, event.clientY, 10, false);
    }

    function onPhotoEnter(event) {
      if (prefersReducedMotion()) return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      const photo = target.closest("[data-flourish]");
      if (!photo) return;
      const now = Date.now();
      if (now - lastPhoto.current < 900) return;
      lastPhoto.current = now;
      const rect = photo.getBoundingClientRect();
      burstAt(rect.left + rect.width * 0.55, rect.top + rect.height * 0.72, 7, true);
    }

    document.addEventListener("click", onClick);
    document.addEventListener("mouseenter", onPhotoEnter, true);
    return () => {
      document.removeEventListener("click", onClick);
      document.removeEventListener("mouseenter", onPhotoEnter, true);
      pending.forEach((id) => window.clearTimeout(id));
    };
  }, []);

  return (
    <div className="burst-layer" aria-hidden="true">
      {bits.map((bit) => (
        <span
          key={bit.id}
          className={`burst-bit burst-bit--${bit.hue}`}
          style={{
            left: bit.x,
            top: bit.y,
            "--dx": `${bit.dx}px`,
            "--dy": `${bit.dy}px`,
            "--rot": `${bit.rot}deg`,
          }}
        >
          <Motif type={bit.type} />
        </span>
      ))}
    </div>
  );
}

export default Personality;
